import { Backdrop, Box, Grid, Link as MuiLink } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import { getPrintFile, searchData } from "src/app-redux/common-actions";
import { useAppSelector } from "src/app-redux/hooks";
import { getWareHouseDetailsByIdAction } from "src/app-redux/warehouse/actions/wareHouseActions";
import { loader as loading, setCurrentItemId } from "src/app-redux/warehouse/wareHouseSlice";
import { colorCodesInventory, filteryByArr } from "src/common/utils/app.dropdowns";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { WereHouseRoute } from "../../were-house.routes";
import { columns } from "./components/columns";
import Drawer from "./components/Drawer";
import { rows } from "./components/rows";
import { useStyles } from "./style";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid2 from "src/components/CommonXGrid/CommonMaterialGrid2";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function ListItems({}: Props): React.ReactElement {
  const classes = useStyles();
  const receiptLoader: any = useAppSelector(gateEntryLoader);

  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const moduleName = WereHouseRoute.title;
  const pageHeading = WereHouseRoute.subRoutes ? WereHouseRoute.subRoutes[1].title : "Page Title";

  const [loader2, setLoader2] = useState<any>(false);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const loader: any = useAppSelector(loading);
  const terminalPageLink = WereHouseRoute.subRoutes
    ? `${WereHouseRoute.path}${WereHouseRoute?.subRoutes[0].path}`
    : "";

  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);
  const [isOpenPrintDailog, setIsOpenPrintDailog] = useState<boolean>(false);
  const [selectedRecordId, setSelectedRecordId] = useState({
    id: null,
    transactionType: null,
  });

  useEffect(() => {
    if (rows.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <MuiLink
                      to={`/link/${row.original.id}`}
                      component={Link}
                      style={{ textDecoration: "none", marginBottom: "8px" }}
                    >
                      <NewCommonButton icon={<EditIcon />} isEdit={true}>
                        Edit
                      </NewCommonButton>
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "itemName"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getWareHouseDetailsByIdAction(row.original.id));
                        dispatch(setCurrentItemId(row.original.id));
                        setisDrawerOpen(true);
                      }}
                    >
                      {renderedCellValue}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "inventoryStatus"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                const colorCode = row.original.inventoryStatusColorCode;
                const bgColorArr: any = colorCodesInventory.filter(
                  (item: any) => item.code == colorCode
                );
                return (
                  <>
                    <span
                      style={{
                        color: colorCode,
                        backgroundColor: `${bgColorArr[0]?.bgCode}`,
                        fontSize: "12px",
                        padding: "4px",
                        fontWeight: "bold",
                      }}
                    >
                      {renderedCellValue}
                    </span>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [rows]);

  const formik = useFormik({
    initialValues: {
      InProgressVehiclesDataOnly: false,
      filterBy: "today",
      vehicleStatusId: 10,
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
    },
    onSubmit: () => {
      // alert(JSON.stringify(values, null, 2));
    },
  });
  const { values, setValues } = formik;
  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
    };
    setGridRecord([]);
    setLoader2(true);
    try {
      const results: any = await dispatch(searchData("/get-all-inventory", JSON.stringify(body)));
      const apiRecord = results?.inventory;
      setGridRecord(apiRecord);
    } catch (error) {
      setLoader2(false);
    }
    setLoader2(false);
  };
  const [resetHandler, setResetHandler] = useState(false);

  const resetSearch = () => {
    setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };
  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    handleSearch();
    setisDrawerOpen(false);
  };

  const handlePrint = (parms: any) => {
    setSelectedRecordId({
      id: parms?.transactionId,
      transactionType: parms?.transactionType,
    });
    setIsOpenPrintDailog(true);
  };

  const printReceipt = async (isDuplicate: string) => {
    setIsOpenPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm ");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-inventory_slip_by_inventory_transaction_id/${selectedRecordId?.id}?transactionType=${selectedRecordId.transactionType}&isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        heading={"Item Details"}
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid2
            rows={gridRecord}
            columns={displayColumns}
            defaultPerPageRecord={15}
            loader={loader2}
            height={550}
            handlePrint={handlePrint}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={4} lg={2}>
              <CommonAutoCompleteField
                error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                helperText={formik.touched.filterBy && formik.errors.filterBy}
                cssClassName="customTextField"
                label="Filter by"
                placeholder="Filter by"
                name="filterBy"
                disableClearable={true}
                optionsType={filteryByArr}
                getOptionLabel={(option: any) => option.label || null}
                onChange={(row: any) => {
                  row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                  if (row === null) {
                    formik.setFieldValue("filterBy", null);
                  }
                  filterByAction(row);
                }}
                value={
                  filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                }
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <Box>
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <Box>
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Box>
            </Grid>
            {/* <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2}></Grid> */}

            <Grid
              item
              xs={12}
              md={isCustomDate ? 12 : 8}
              lg={isCustomDate ? 6 : 10}
              direction="row"
            >
              <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                  Search
                </CommonButton>

                <MuiLink
                  to={terminalPageLink}
                  component={Link}
                  style={{ textDecoration: "none", marginBottom: "8px" }}
                >
                  <NewCommonButton
                    cssClass="customSubmitBtn"
                    mr0={true}
                    style={{ marginLeft: "10px" }}
                    isEdit={true}
                  >
                    Add Inventory Item
                  </NewCommonButton>
                </MuiLink>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
      <DuplicateReceiptDialog
        isOpen={isOpenPrintDailog}
        handleOriginal={() => {
          printReceipt("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceipt("1");
        }}
        onClose={() => {
          setIsOpenPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
    </>
  );
}
